// Low quality (UX §7 Settings "Low quality"; the M7 proposal "a tiny fx/quality.ts beside fx/motion.ts"): the
// EFFECTIVE flag the FX read at every effect batch — fewer particles (juice.json lowQuality.particleScale)
// and the lower particle cap (caps.particlesLow). The UI shell sets it (main.ts `applyQuality`: M7 Settings
// "Low quality" or `?quality=low`, L17). Kept apart from fx/motion.ts (the L16 contract file).
let low = false;

/** True while Low quality is in effect. */
export function lowQuality(): boolean {
  return low;
}

/** Sets the effective flag (Settings "Low quality" or `?quality=low`). */
export function setLowQuality(v: boolean): void {
  low = v;
}
